import React from 'react';
import TextField from '@material-ui/core/TextField';
import AutoComplete from '@material-ui/lab/Autocomplete';
import Dialog from '@material-ui/core/Dialog';
import MyLocationRounded from '@material-ui/icons/MyLocationRounded';
import CloseRounded from '@material-ui/icons/CloseRounded';

import Component from '../../../../../ui-components/Component';
import { withResizer, withUser } from '../../../../../HoCs';
import { merge, isEmptyObject, path, deepCheck, isEmptyList } from '../../../../../utils';
import LocationPicker from '../../../../../ui-components/LocationPicker';
import styles from './styles';
import IconButton from '../../../../../ui-components/Button/Icon';
import { fetchLocation, fetchCountries, fetchCities } from './interactor';
import { rowCenter } from '../../../../../resources/styles';
import ImageUploader from '../../../../../ui-components/ImageUploader';
import { handleNetworkError, showErrorSnack, showWarningSnack } from '../../../../../ui-components/utils';
import { isEmptyString } from '../../../../../utils';
import { isNumber } from '../../../../../utils/functionUtils';
import Network from '../../../../../services/Network';
import LineLoader from '../../../../../ui-components/Loader/Line';

class ManualForm extends Component {

    styles = styles;

    state = {
        locationPickerOn: false,
        countries: [],
        cities: [],
        citySuggestionLoader:false,
        property_name: '',
        room_count: '',
        location: null,
        address: '',
        country: null,
        city: null,
        images: [],
    };

    locationFieldRef = React.createRef();
    imageUploaderRef = React.createRef();

    componentDidMount = () => {
        fetchCountries(countries => this.setState({ countries }, () => !isEmptyObject(this.props.data) && this.prefill()), handleNetworkError);
        const {properties_count, room_count} = this.props.userData || {};
        
        if(room_count && properties_count == 0){
            this.setState({room_count})
        }
    };

    componentDidUpdate = pProps => !deepCheck(pProps.data, this.props.data) && !isEmptyObject(this.props.data) && this.prefill();

    onCountryChange = () => {
        this.setState({ cities: [], city: null });
        path(this.state.country, 'id') != null && fetchCities(this.state.country.id, cities => this.setState({ cities }), handleNetworkError);
    };

    inputChanger = key => e => {
        switch(key){
            case 'room_count':
                if(!isNumber(e.target.value))return;
                break;
            default:
                break;
        }
        this.setState({ [key]: e.target.value })
    };
    renderInput = (key, label, style) => <TextField variant='outlined' size='small' style={merge(this.gs('field'), style)} label={this.props.gc(label) + '*'} value={this.state[key]} onChange={this.inputChanger(key)} />

    optionChanger = (key, onChange) => (e, value) => this.setState({ [key]: value }, onChange);
    renderAutoComplete = (valueKey, optionsKey, label, style, onChange) => <AutoComplete size='small' style={merge(this.gs('field'), style)} options={this.state[optionsKey]} getOptionLabel={option => option.name} value={this.state[valueKey]} onChange={this.optionChanger(valueKey, onChange)} renderInput={params => <TextField {...params} label={label} variant="outlined" inputProps={{ ...params.inputProps, autoComplete: 'new-password' }} />} />

    render = () => <div style={merge(this.gs('container'), this.props.style)}>
        {this.renderInput('property_name', 'name_of_property')}
        {this.renderInput('room_count', 'no_of_rooms')}
        <TextField variant='outlined' size='small' style={this.gs('field')} label={this.props.gc('geo_location')+'*'} onClick={this.openLocationPicker(this.state.location)}
            InputProps={{ endAdornment: navigator.geolocation ? <MyLocationRounded onClick={this.onFetchLocation} style={this.gs('my_loc')} /> : null }} disabled
            inputRef={this.locationFieldRef} value={this.getLatLngString()}
        />
        {this.renderInput('address', 'property_address')}
        <div style={{alignSelf:'center',padding:'0 12px',maxWidth:'360px',width:'100%',boxSizing:'border-box'}}><LineLoader visible={this.state.citySuggestionLoader}/></div>
        <div style={merge(rowCenter, { flexWrap: 'wrap' })}>
            {this.renderAutoComplete('country', 'countries', 'Country*', { flex: 1 }, this.onCountryChange)}
            {this.renderAutoComplete('city', 'cities', 'City*', { flex: 1 })}
        </div>
        <div style={this.gs('upload_title')}>Upload Image<div style={this.gs('optional')}>(Optional)</div></div>
        <div style={this.gs('add_image_container')}><ImageUploader ref={this.imageUploaderRef} urls={this.state.images} /></div>
        {this.renderLocationDialog()}
    </div>;

    onFetchLocation = e => {
        e.stopPropagation();
        fetchLocation(location => this.openLocationPicker(location)());
    };
    
    openLocationPicker = location => () => this.setState({ locationPickerOn: true, location }, () => this.locationFieldRef.current.blur());
    closeLocationPicker = () => this.setState({ locationPickerOn: false });
    onLocationPicked = data => {
        // TODO: Add city null check?? Should we fetch suggestion of city is already filled?
        //if(this.state.city == null)
        this.getCityCountrySuggestion(path(data,'location'));
        this.setState({ ...(data ? data : {}), locationPickerOn: false })
    };
    getLatLngString = () => isEmptyObject(this.state.location) ? '' : `${this.state.location.lat}, ${this.state.location.lng}`;
    
    getCityCountrySuggestion = (location) => {
        if(location == null)return;
        this.setState({citySuggestionLoader:true});
        Network.GET('v1/oam/city_country_suggestion',{
            lat:path(location,'lat'),
            lng:path(location,'lng'),
            'fetch_entity_ids':true
        },null,res => {
            this.setState({citySuggestionLoader:false});
            
            if(isEmptyList(res.cities) || isEmptyObject(res.city) || isEmptyList(res.countries) || isEmptyObject(res.country)){
                showWarningSnack(this.props.gc('couldnt_fetch_country'))
            }
            
            if(!isEmptyList(res.cities)){
                this.setState({cities:res.cities});
    
                if(!isEmptyObject(res.city)){
                    this.setState({city:res.cities.find(c => c.id == path(res,'city.id'))})
                }
                
            }
            if(!isEmptyList(res.countries)){
                this.setState({countries:res.countries});
    
                if(!isEmptyObject(res.country)){
                    this.setState({country:res.countries.find(c => c.id == path(res,'country.id'))})
                }
            }
            
        },err => {
            this.setState({citySuggestionLoader:false});
            showErrorSnack(this.props.gc('couldnt_fetch_country'))
        })
    };

    renderLocationDialog = () => <Dialog keepMounted maxWidth='lg' open={this.state.locationPickerOn}
        PaperProps={{ style: { height: '100%', width: '100%' } }} fullScreen={this.getWidth() <= 700}
        onClose={this.closeLocationPicker}>
        <div style={this.gs('location_dialog_header')}>
            <div style={this.gs('location_dialog_title')}>{this.props.gc('pin_exact_location')}</div>
            <IconButton onClick={this.closeLocationPicker}><CloseRounded /></IconButton>
        </div>
        <LocationPicker center={this.state.location} onPicked={this.onLocationPicked} />
    </Dialog>;

    getAnswers = validate => {
        if (this.validateFields()) {
            return {
                property_name: this.state.property_name,
                address: this.state.address,
                city: path(this.state.city, 'name'),
                city_id: path(this.state.city, 'id'),
                country: path(this.state.country, 'name'),
                lat: path(this.state.location, 'lat'),
                lng: path(this.state.location, 'lng'),
                room_count: this.state.room_count,
                image_url: path(this.imageUploaderRef.current, 'getUrls', () => ([]))(),
                'source': 'OAM',
                'sub_source': 'Self on-boarding',
                'supply_model_type': 'Hotel',
                scraping_request_id:this.state.scraping_request_id
            }
        } else return false;
    };

    validateFields = () => {
        if (isEmptyString(this.state.property_name)) {
            showErrorSnack(this.props.gc('please_enter_property_n'))

        } else if(isEmptyString(this.state.address)){
            showErrorSnack(this.props.gc('please_enter_property'))
        }
        else if(isEmptyObject(this.state.city)){
            showErrorSnack(this.props.gc('please_select_city'))
        }else if(isEmptyString(path(this.state.location,'lat','')) || isEmptyString(path(this.state.location,'lng',''))){
            showErrorSnack(this.props.gc('please_select_lat_long'))
        }
        else if(!isNumber(this.state.room_count) || this.state.room_count<=0){

            showErrorSnack(this.props.gc('please_enter_correct'))
        }else{
            return true
        }
    };

    prefill = () => {
        // TODO: get room count from user DTO
        let location = path(this.props.data, 'lat') && path(this.props.data, 'lng') ? { lat: this.props.data.lat, lng: this.props.data.lng } : null;
        
        // this means that prefill was done from property's own data. So no need for city/country suggestions
        if(path(this.props.data,'property_unique_id') == null) this.getCityCountrySuggestion(location);
        
        this.setState({
            property_name: path(this.props.data, 'property_name', ''),
            room_count: path(this.props.data, 'room_count', this.state.room_count),
            location: location,
            address: path(this.props.data, 'address', ''),
            scraping_request_id:path(this.props.data,'scraping_request_id'),
            images: !isEmptyList(path(this.props.data, 'image_url')) ? this.props.data.image_url : [],
        });

        const onCountriesFetched = () => {
            if (isEmptyString(path(this.props.data, 'country'))) return;
            const country = this.state.countries.find(item => item.name === this.props.data.country) || null;
            const onCitiesFetched = () => {
                const city = isEmptyString(path(this.props.data, 'city')) ? null
                    : this.state.cities.find(item => item.name.toLowerCase() === this.props.data.city.toLowerCase()) || null;
                this.setState({ country, city });
            };
            if (path(country, 'id') != null) fetchCities(country.id, cities => this.setState({ cities }, onCitiesFetched), handleNetworkError);
        };
        if (isEmptyList(this.state.countries)) fetchCountries(countries => this.setState({ countries }, onCountriesFetched));
        else onCountriesFetched();
    }

}

export default withUser(withResizer(ManualForm));